import { NodeViewWrapper } from "@tiptap/react";
import React, { useEffect, useState } from "react";
import ImageUpload from "../../components/ImageUpload";

export const IMAGE_DELETE_EVENT = "image-node-delete-request";

const ImageComponent = (props) => {
  const { node, editor, getPos } = props;
  const [deleteRequest, setDeleteRequest] = useState(0);
  const updateCaption = (caption) => {
    props.updateAttributes({
      caption,
    });
  };

  useEffect(() => {
    const onDeleteRequest = (e) => {
      if (e.detail?.pos === getPos()) {
        setDeleteRequest((count) => count + 1);
      }
    };
    window.addEventListener(IMAGE_DELETE_EVENT, onDeleteRequest);
    return () =>
      window.removeEventListener(IMAGE_DELETE_EVENT, onDeleteRequest);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <NodeViewWrapper
      style={{ margin: "16px 0", display: "flex", flexDirection: "column" }}
      data-drag-handle
      className="react-component-with-content"
    >
      <ImageUpload
        editor={editor}
        src={node.attrs.src}
        caption={node.attrs.caption}
        updateCaption={updateCaption}
        deleteRequest={deleteRequest}
      />
    </NodeViewWrapper>
  );
};
export default ImageComponent;
